import { render, staticRenderFns } from "./ExecutionUpdateDetails.vue?vue&type=template&id=23516bfe&scoped=true&"
import script from "./ExecutionUpdateDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExecutionUpdateDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExecutionUpdateDetails.vue?vue&type=style&index=0&id=23516bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23516bfe",
  null
  
)

export default component.exports